export default __webpack_public_path__ + "static/media/p16.316b6d2b.jpeg";